module.exports = __webpack_public_path__ + "img/greek_ideas.144faf80.jpg";